import { z } from 'zod';

import {
    CONFIRM_PASSWORD_FIELD,
    EMAIL_FIELD,
    FAMILY_NAME_FIELD,
    GIVEN_NAME_FIELD,
    MARKETING_FIELD,
    PASSWORD_FIELD,
    TEL_FIELD,
    USERNAME_FIELD,
} from './registration.constants';

export const registrationStepOneSchema = () =>
    z
        .object({
            [USERNAME_FIELD.name]: z
                .string()
                .min(5, { message: 'registration.step-one.username.min-length.error' })
                .max(20, { message: 'registration.step-one.username.max-length.error' })
                .regex(/^[a-z0-9]+$/, {
                    message: 'registration.step-one.username.invalid-characters.error',
                }),
            [GIVEN_NAME_FIELD.name]: z
                .string()
                .min(1, { message: 'registration.step-one.given-name.min-length.error' })
                .max(32, { message: 'registration.step-one.given-name.max-length.error' })
                .regex(/^.+$/, {
                    message: 'registration.step-one.given-name.invalid-characters.error',
                }),
            [FAMILY_NAME_FIELD.name]: z
                .string()
                .min(1, { message: 'registration.step-one.family-name.min-length.error' })
                .max(32, { message: 'registration.step-one.family-name.max-length.error' })
                .regex(/^.+$/, {
                    message: 'registration.step-one.family-name.invalid-characters.error',
                }),
            [EMAIL_FIELD.name]: z
                .string()
                .email({ message: 'registration.step-one.email.invalid-email.error' }),
            // [TEL_PREFIX_FIELD.name]: z
            //     .string()
            //     .min(2, { message: 'registration.step-one.telephone-prefix.select-prefix.error' }),
            [TEL_FIELD.name]: z
                .string()
                .max(10, { message: 'registration.step-one.telephone.invalid-type.error' })
                .regex(/^\d{10}$/, 'registration.step-one.telephone.invalid-type.error'),
            [PASSWORD_FIELD.name]: z
                .string()
                .min(8, { message: 'registration.step-one.password.min-length.error' })
                .max(32, { message: 'registration.step-one.password.max-length.error' })
                .regex(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,32}$/, {
                    message: 'registration.step-one.password.invalid-characters.error',
                }),
            [CONFIRM_PASSWORD_FIELD.name]: z
                .string()
                .min(8, { message: 'registration.step-one.confirm-password.min-length.error' })
                .max(32, { message: 'registration.step-one.confirm-password.min-length.error' })
                .regex(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,32}$/, {
                    message: 'registration.step-one.confirm-password.min-length.error',
                }),
            [MARKETING_FIELD.name]: z.boolean(),
        })
        .refine((data) => data[PASSWORD_FIELD.name] === data[CONFIRM_PASSWORD_FIELD.name], {
            message: 'registration.step-one.password.do-not-match.error',
            path: ['passwordConfirm'],
        });
